// EquipmentDetails.jsx
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './css/EquipmentDetails.css';

const fields = [
    { key: 'tag', label: 'Tag' },
    { key: 'name', label: 'Name' },
    { key: 'category', label: 'Category' },
    { key: 'location', label: 'Location' },
    { key: 'serves', label: 'Serves' },
    { key: 'installDate', label: 'Install date' },
    { key: 'commissioningDate', label: 'Commissioning date' },
    { key: 'warrantyDate', label: 'Warranty date' },
    { key: 'drawingRef', label: 'Drawing reference' },
    { key: 'specRef', label: 'Specification reference' },
];

export default function EquipmentDetails({ equipment }) {
    if (!equipment) return null;

    return (
        <Card title={`${equipment.name}:`}>
            <div className="equipment-details-grid">
                {fields.map(({ key, label }) => (
                    <div className="equipment-details-field" key={key}>
                        <label htmlFor={`equipment-${key}`}>{label}</label>
                        <InputText
                            id={`equipment-${key}`}
                            value={equipment[key] == null ? '' : String(equipment[key])}
                            readOnly
                            className="equipment-details-input"
                        />
                    </div>
                ))}
            </div>
            <br />
            <br />
            <DataTable value={equipment.parameters} tableStyle={{ minWidth: '50rem' }}
                header="Parameters">
                <Column field="label" header="Name"></Column>
                <Column field="value" header="Value"></Column>
                <Column field="unit" header="Unit"></Column>
            </DataTable>
        </Card>
    );
}